export const detectLeftButton = e => {
    e = e || window.event;
    if ("buttons" in e) {
        return e.buttons === 1;
    }
    let button = e.which || e.button;
    return button === 1;
};